export default "__VITE_ASSET__D$h1TDIW__"